<div mat-dialog-content>{{data.message}}</div>
<mat-dialog-actions align="center">
  <button mat-raised-button mat-dialog-close>{{"Cancel" | translate}}</button>
  <button mat-raised-button color="primary" class="Yes" [mat-dialog-close]="true">
    {{"Yes" | translate}}
  </button>
</mat-dialog-actions>
